<template>
  <b-container>
  <div>
  </div>
  </b-container>
</template>

<script>
  import { sync } from "vuex-pathify";
  import store from "../store";
  import vx_api from "../vuemix";

  export default {
  name: "signout",
  data() {
    return {
      addlistener: true,
    };
  },
  components: {
  },
  created() {
  },
  mounted() {
    console.log("Mounted signout");
    let vue=this;
    vue.$parent.signUserOut("quiet");
  },
  beforeDestroy() {
    //console.log("Destroy");
    let vue=this;
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.container {
}

</style>
